import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=5364df60&scoped=true"
import script from "./Promotion.vue?vue&type=script&lang=ts"
export * from "./Promotion.vue?vue&type=script&lang=ts"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=5364df60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364df60",
  null
  
)

export default component.exports